import { useMutation, gql } from "@apollo/client";

export const DELETE_USER_DOCUMENT = gql`
  mutation useDeleteUserDocument($input: DeleteUserDocumentInput!) {
    deleteUserDocument(input: $input) {
      id
    }
  }
`;

export default (options) => {
  return useMutation(DELETE_USER_DOCUMENT, options);
};
